<script setup lang="ts">
import { onMounted, ref } from 'vue';

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <transition name="fade-in-out">
    <slot v-if="isVisible" />
  </transition>
</template>

<style scoped lang="scss">
.fade-in-out-enter-active,
.fade-in-out-leave-active {
  transition: opacity var(--transition-very-short);
}

.fade-in-out-enter-from,
.fade-in-out-leave-to {
  opacity: 0;
}
</style>
